import React, { FC } from 'react';
import { Divider, Typography } from 'antd';

import { getGauntletProgress } from '@services/cstool/recovery-account';

import GauntletLineupSearch from './gauntlet-lineup-search';
import ProgressSearch from './progress-search';

const { Title } = Typography;

const Gauntlet: FC = () => (
  <div className="flex flex-col">
    <Title level={4}>Gauntlet Progress</Title>
    <ProgressSearch
      fetchProgress={getGauntletProgress}
      downloadFileName={(playerId) => `gauntlet-${playerId}.txt`}
    />
    <Divider />
    <Title level={4}>Gauntlet Lineup</Title>
    <GauntletLineupSearch />
  </div>
);

export default Gauntlet;
